import { createAction, props } from '@ngrx/store';

export const ProductImagesRequest = createAction('[Product images] Request', props<{ params: APICommon.ImagesGetParams; productIds: number[] }>());

export const ProductImagesSuccessRequest = createAction('[Product images] Success request', props<{ payload: OLO.DTO.ImageUrlModel[]; productIds: number[] }>());

export const ProductImagesErrorRequest = createAction('[Product images] Error request', props<{ productIds: number[]; ex?: any }>());
